import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
import { ml, mr } from '@lendi-ui/spacing';
import { Body, overline } from '@lendi-ui/typography';

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Prefix = styled(Body)`
  ${ml('xxs')};
  color: ${() => getColour('text', 'subtle')};
`;

export const Suffix = styled(Body)`
  ${overline({ size: 'lg' })};
  ${mr('xxs')};
  color: ${() => getColour('text', 'subtle')};
`;
